"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LanguageSwitcherFeature = void 0;
const LanguageSwitcherFeature = exports.LanguageSwitcherFeature = {
  /** Disable language switcher popup */
  DisableLanguageSwitcherPopUp: 'D9541F82-7C57-4346-BA02-3D32EEB3C78C'
};
